"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_dom_1 = require("react-dom");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var SliderPanel = /** @class */ (function (_super) {
    tslib_1.__extends(SliderPanel, _super);
    function SliderPanel(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.resize = function () {
            if (_this.child) {
                utils_1.caf(_this.resizeRafId);
                _this.resizeRafId = utils_1.raf(function () {
                    if (_this.willUnmount) {
                        return;
                    }
                    var nextState = {
                        width: _this.child.offsetWidth
                    };
                    if (_this.state.width !== nextState.width) {
                        _this.setState(nextState);
                    }
                });
            }
        };
        _this.triggetShowChange = function () {
            var onShowChange = _this.props.onShowChange;
            onShowChange(_this.state.show);
        };
        _this.setChildRef = function (el) {
            _this.child = el;
        };
        _this.child = null;
        _this.resizeRafId = null;
        _this.willUnmount = false;
        _this.offsetObserver = null;
        _this.state = { width: 0, show: false };
        _this.onIntersectionChange = _this.onIntersectionChange.bind(_this);
        return _this;
    }
    SliderPanel.prototype.componentDidMount = function () {
        var disabled = this.props.disabled;
        if (!disabled) {
            this.register();
        }
    };
    SliderPanel.prototype.componentWillUnmount = function () {
        this.willUnmount = true;
        this.unregister();
    };
    SliderPanel.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (!this.props.disabled && nextProps.disabled) {
            this.unregister();
        }
        else if (this.props.disabled && !nextProps.disabled) {
            this.register();
        }
        else if (this.props.offset !== nextProps.offset) {
            this.unregister();
            this.register();
        }
    };
    SliderPanel.prototype.register = function () {
        window.addEventListener("resize", this.resize, false);
        this.observeOffset();
    };
    SliderPanel.prototype.unregister = function () {
        window.removeEventListener("resize", this.resize, false);
        this.stopOffsetObserver();
    };
    SliderPanel.prototype.stopOffsetObserver = function () {
        if (this.offsetObserver) {
            this.offsetObserver.disconnect();
            this.offsetObserver = null;
        }
    };
    SliderPanel.prototype.observeOffset = function () {
        this.stopOffsetObserver();
        if (this.child) {
            var node = react_dom_1.findDOMNode(this.child);
            if (node) {
                var options = {};
                if (this.props.offset) {
                    options.rootMargin = this.props.offset + "px";
                }
                this.offsetObserver = new IntersectionObserver(this.onIntersectionChange, options);
                this.offsetObserver.observe(node);
            }
        }
    };
    SliderPanel.prototype.onIntersectionChange = function (entries, observer) {
        var isIntersecting = entries[0].isIntersecting;
        this.setState({
            width: this.child.offsetWidth,
            show: !isIntersecting
        }, this.triggetShowChange);
    };
    SliderPanel.prototype.render = function () {
        var _a = this.props, theme = _a.theme, children = _a.children, disabled = _a.disabled, sliderClassName = _a.sliderClassName, panelClassName = _a.panelClassName, zIndex = _a.zIndex;
        var sliderClasses = classnames_1.default(theme.slider, sliderClassName);
        var panelClasses = classnames_1.default(theme.panel, panelClassName);
        var width = this.state.width;
        var show = !disabled && this.state.show;
        return (React.createElement(React.Fragment, null,
            React.cloneElement(React.Children.only(children), {
                ref: this.setChildRef
            }),
            React.createElement("div", { className: sliderClasses, style: {
                    transform: "translateY(" + (show ? 0 : 100) + "%)",
                    opacity: show ? 1 : 0,
                    zIndex: zIndex
                } },
                React.createElement("div", { className: panelClasses, style: { width: width } }, children))));
    };
    SliderPanel.defaultProps = {
        zIndex: 10,
        offset: 0,
        onShowChange: utils_1.noop
    };
    return SliderPanel;
}(React.Component));
exports.default = SliderPanel;
